export const styles = {
    tableCard:
      "bg-white dark:bg-gray-800 p-0 rounded-lg mt-9 border border-gray-200 dark:border-gray-700 overflow-y-auto sm:overflow-y-auto",
    container:
      "bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4 relative before:absolute before:left-0 before:right-0 before:top-[60px] before:h-[1px] before:bg-gray-200 dark:before:bg-gray-700",
    header: "px-0 py-1",
    title: "text-theme-xl font-semibold text-gray-800 dark:text-white/90",
    headerControls:
      "flex flex-col md:flex-row justify-between items-center p-4 border-b border-white dark:border-gray-700 bg-white dark:bg-gray-800 gap-4 md:gap-6",
    controlsInner:
      "flex flex-wrap md:flex-nowrap items-center w-full md:w-auto gap-2 md:gap-2",
    searchContainer: "relative flex items-center flex-1 w-full md:w-auto h-10",
    searchInput:
      "dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent py-2.5 pl-11 pr-4 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 md:w-[180px] xl:w-[200px]",
    searchIcon: "absolute left-3 text-gray-400 dark:text-gray-300 w-4 h-4",
    downloadButton:
      "inline-flex items-center justify-center rounded-lg transition px-4 py-2 md:py-3 text-sm bg-white text-gray-700 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-400 dark:ring-gray-700 dark:hover:bg-white/[0.03] dark:hover:text-gray-300",
    downloadIcon: "w-5 h-5 ml-2",
    addButtonContainer: "w-full md:w-auto",
    addButton:
      "inline-flex items-center justify-center gap-1 md:gap-2 rounded-md md:rounded-lg transition px-3 py-2 md:px-4 md:py-3 text-xs md:text-sm bg-[#2f6aa7] dark:bg-[#3d6794] text-white shadow-theme-xs hover:bg-[#2779bd] dark:hover:bg-[#335877] disabled:bg-brand-300 w-full md:w-auto",
    errorText: "text-red-500 text-xs",
    expiredText: "text-red-600 dark:text-red-600",
    expiredRow: "",
    tableContainer: "overflow-x-auto max-h-[500px] block", 
    table: "w-full border-collapse table-auto min-w-[600px] border-separate border-spacing-0",
    theadRow: "sticky top-0 z-10 bg-white dark:bg-gray-900 text-left font-medium text-gray-700 theme-xs dark:text-gray-400 border-b border-gray-300 dark:border-gray-700",
    thName:
      "min-w-[80px] md:min-w-[100px] px-3 py-2 md:px-4 md:py-3 border border-gray-100 dark:border-white/[0.05]",
    thECD:
      "min-w-[120px] md:min-w-[150px] px-2 py-2 md:px-4 md:py-3 border border-gray-100 dark:border-white/[0.05]",
    thTexts:
      "min-w-[80px] px-2 py-2 md:px-3 md:py-3 border border-gray-100 dark:border-white/[0.05] text-xs md:text-sm",
    thAction:
      "w-[100px] md:w-[150px] px-2 py-2 md:px-4 md:py-3 border border-gray-100 dark:border-white/[0.05] text-xs md:text-sm",
    thLog:
  "w-[40px] px-2 py-2 sm:px-2 sm:py-3 border border-gray-100 dark:border-white/[0.05] text-xs sm:text-sm",

    thSortable: "flex items-center justify-between cursor-pointer",
    thText:
      "w-[50px] md:w-[50px] font-bold text-gray-800 text-theme-xs md:text-sm dark:text-gray-400",
    sortButton: "flex flex-col gap-0.5",
    tbodyRow: "border border-gray-100 dark:border-white/[0.05]",
    td: "w-[60px] px-2 py-4 font-normal text-gray-800 dark:text-gray-400 text-theme-sm border border-gray-100 dark:border-white/[0.05] break-words",
    th: "px-4 py-3 border border-gray-100 dark:border-white/[0.05] text-sm",
    tdName: "px-2 py-2 md:px-3 md:py-4 font-normal text-gray-800 dark:text-gray-400 text-theme-sm md:text-theme-sm border border-gray-100 dark:border-white/[0.05] max-w-[120px] md:max-w-[140px] break-words",
    tdProfileImage:
      "w-[80px] md:w-[120px] px-2 py-2 md:px-4 md:py-4 border border-gray-100 dark:border-white/[0.05] cursor-pointer",
    profileImage: "w-8 h-8 md:w-10 md:h-10 rounded-full object-cover",
    tdRole:
      "px-2 py-2 md:px-4 md:py-4 font-normal text-gray-800 dark:text-gray-400 text-theme-sm md:text-theme-sm border border-gray-100 dark:border-white/[0.05] max-w-[160px] md:max-w-[200px] break-words",
    tdStatus:
      "px-2 py-2 md:px-4 md:py-4 border border-gray-100 dark:border-white/[0.05]",
    tdAction: "w-[70px] md:w-[120px] px-2 py-2 md:px-4 md:py-4 border border-gray-100 dark:border-white/[0.05]",
    viewButton:
      "shrink-0 w-6 h-6 bg-green-600 dark:bg-green-500 flex items-center justify-center rounded-md shadow hover:bg-green-400 dark:hover:bg-green-600 transition",
    statusContainer: "flex items-center gap-2",
    statusToggle:
      "w-10 h-5 md:w-10 md:h-5 rounded-full flex items-center px-0.5 transition-all",
    statusToggleActive: "bg-green-500",
    statusToggleInactive: "bg-red-500",
    statusToggleCircle:
      "w-3.5 h-3.5 md:w-4 md:h-4 bg-white rounded-full transition-transform",
    statusToggleCircleActive: "translate-x-4 md:translate-x-5",
    statusToggleCircleInactive: "translate-x-0",
    statusBadge:
      "text-xs inline-flex items-center justify-center px-3 py-0.5 rounded-full",
    statusActive: "bg-green-100 text-green-700",
    statusInactive: "bg-red-100 text-red-700",
    actionContainer: "flex justify-start items-center space-x-1.5",
    editButton: "shrink-0 w-6 h-6 bg-[#2f6aa7] dark:bg-[#3d6794]  flex items-center justify-center rounded-md shadow hover:bg-[#2779bd] dark:hover:bg-[#335877] transition",
    deleteButton: "shrink-0 w-6 h-6 bg-red-600  dark:bg-red-400 flex items-center justify-center rounded-md shadow hover:bg-red-500 dark:hover:bg-red-600 transition",
    downloadsButton:
      "shrink-0 w-6 h-6 bg-[#d2a81b] dark:bg-[#d4b035]  flex items-center justify-center rounded-md shadow hover:bg-[#e7ba1f] dark:hover:bg-[#ffaf33] transition",
    emailButton: "shrink-0 w-6 h-6 bg-[#167968] dark:bg-[#20ac95]  flex items-center justify-center rounded-md shadow hover:bg-[#20ac95] dark:hover:bg-[#167968] transition",
    actionIcon: "w-3 h-3 md:w-4 md:h-4",
    loadingRow: "border-none",
    loadingText: "text-center text-gray-500 dark:text-gray-400 py-4 !border-0",
    noDataText: "text-center text-gray-500 dark:text-gray-400 py-4 !border-0",
    modal:
      "w-[80%] max-w-[400px] bg-white dark:bg-gray-900 px-6 py-6 rounded-lg shadow-xl mx-auto text-center relative",
    modalCloseButton:
      "absolute top-3 right-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200",
    modalIconContainer:
      "w-14 h-14 flex items-center justify-center bg-red-100 text-red-600 rounded-full",
    modalIcon: "w-6 h-6",
    modalTitle: "text-lg font-bold text-gray-800 dark:text-white mt-4",
    modalText: "text-sm text-gray-500 dark:text-gray-400 mt-2",
    modalButtonContainer: "mt-6 flex justify-center gap-4",
    modalCancelButton:
      "px-4 py-2 border border-gray-300 text-gray-700 dark:text-white rounded-md hover:bg-gray-100 dark:border-gray-600 dark:hover:bg-gray-700",
    modalDeleteButton: "px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700",
  };